import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormFieldControlService } from '../../../services/form-field-control.service';
import { FormField } from '../../../shared/form-field/form-field';

@Component({
  standalone: false,
  selector: 'service-search-modal',
  templateUrl: 'service-search-modal.template.html',
  styleUrls: ['service-search-modal.scss'],
  providers: [FormFieldControlService],
})
export class ServiceSearchModalComponent implements OnInit {
  @Input() formFields: FormField<string>[] = [];
  form: FormGroup;
  payLoad = '';

  constructor(private qcs: FormFieldControlService) {}

  ngOnInit() {
    this.form = this.qcs.toFormGroup(this.formFields);
  }

  onSubmit() {
    // TODO: on submit
  }
}
